<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane
                directory-scope="teaching"
                pane-title="家校通讯录"
                @tree-node-click="treeNodeClick"
            ></DepartmentPane>
        </section>

        <section class="dp-right">
            <div class="toolbar-filter-bar">
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-form :inline="true" :model="filters" class="toolbar-filter-form">
                    <div class="toolbar-filter-fields">
                    <el-form-item>
                        <el-input v-model="filters.teacherName" placeholder="教师姓名" clearable class="toolbar-field-w-md"
                            @clear="onTeacherNameCleared"></el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-select v-model="filters.operationType" placeholder="类型" clearable
                            class="toolbar-field-w-type" @change="handleSearch">
                            <el-option label="全部类型" :value="0"></el-option>
                            <el-option label="代课" :value="1"></el-option>
                            <el-option label="被代课" :value="2"></el-option>
                            <el-option label="调课" :value="3"></el-option>
                            <el-option label="教务安排(待指派)" :value="4"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item>
                        <el-select v-model="filters.reasonType" placeholder="申请原因" clearable
                            class="toolbar-field-w-md" @change="handleSearch">
                            <el-option v-for="item in reasonTypeOptions" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>

                    <!-- 保留学期选择 -->
                    <el-form-item>
                        <el-select v-model="selectedSemesterId" placeholder="学期" @change="handleSemesterChange"
                            class="toolbar-field-w-md">
                            <el-option v-for="sem in semesterList" :key="sem.Id" :label="sem.SemesterName"
                                :value="sem.Id"></el-option>
                        </el-select>
                    </el-form-item>

                    <!-- 快捷时间筛选 (文字链接样式) -->
                    <el-form-item style="margin-left: 20px;">
                        <el-link :type="timeRange === 'today' ? 'primary' : 'default'"
                            @click="handleTimeRangeChange('today')" style="margin-right: 15px;"
                            :underline="false">今日</el-link>
                        <el-link :type="timeRange === 'week' ? 'primary' : 'default'"
                            @click="handleTimeRangeChange('week')" style="margin-right: 15px;"
                            :underline="false">本周</el-link>
                        <el-link :type="timeRange === 'month' ? 'primary' : 'default'"
                            @click="handleTimeRangeChange('month')" style="margin-right: 15px;"
                            :underline="false">本月</el-link>
                        <el-link :type="timeRange === 'semester' ? 'primary' : 'default'"
                            @click="handleTimeRangeChange('semester')" style="margin-right: 15px;"
                            :underline="false">全学期</el-link>

                        <el-dropdown trigger="click" @command="handleCustomTimeCommand" style="margin-right: 20px;"
                            placement="bottom">
                            <span class="el-dropdown-link"
                                :style="{ color: timeRange === 'custom' ? 'var(--btn-primary, #2563eb)' : '#606266', cursor: 'pointer', fontSize: '14px' }">
                                自定义时间<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown" style="padding: 10px;">
                                <div @click.stop>
                                    <el-date-picker v-model="filters.dateRange" type="daterange" format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"
                                        :clearable="false" size="small" @change="onCustomDateChange"
                                        class="toolbar-field-w-daterange">
                                    </el-date-picker>
                                </div>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" size="small" icon="el-icon-search" v-on:click="handleSearch">查询</el-button>
                    </el-form-item>
                    </div>
                    <div class="toolbar-filter-actions">
                        <el-button size="small" type="warning" icon="el-icon-download" @click="exportExcel"
                            :title="activeTab === 'applications' ? '导出当前筛选下的申请记录' : '导出统计与调课明细'">
                            {{ activeTab === 'applications' ? '导出申请记录' : '导 出' }}
                        </el-button>
                    </div>
                </el-form>
            </el-col>
            </div>

            <el-tabs v-model="activeTab" class="cas-tabs" @tab-click="onTabClick">
                <el-tab-pane label="统计" name="stats">
            <!-- 汇总指标条：全宽等分、紧凑密度。最后更新：2026-09-14 -->
            <div class="stat-summary" v-loading="listLoading">
                <div class="stat-summary-item is-clickable" @click="showSummaryDetail(1)">
                    <span class="stat-summary-label">代课</span>
                    <span class="stat-summary-value">{{ summary.TotalSubstituteCount || 0 }}</span>
                </div>
                <div class="stat-summary-item is-clickable" @click="showSummaryDetail(2)">
                    <span class="stat-summary-label">被代课</span>
                    <span class="stat-summary-value">{{ summary.TotalBeSubstitutedCount || 0 }}</span>
                </div>
                <div class="stat-summary-item is-clickable" @click="showSummaryDetail(3)">
                    <span class="stat-summary-label">调课</span>
                    <span class="stat-summary-value">{{ summary.TotalSwapCount || 0 }}</span>
                </div>
                <div class="stat-summary-item is-pending is-clickable" @click="showSummaryDetail(4)">
                    <span class="stat-summary-label">教务安排(待指派)</span>
                    <span class="stat-summary-value">{{ summary.TotalAdminArrangePendingCount || 0 }}</span>
                </div>
            </div>

            <!--列表：tbl-scroll-host 吃满剩余高度，表体内滚。最后更新：2026-09-21 -->
            <div class="tbl-scroll-host">
            <el-table :data="statistics" highlight-current-row v-loading="listLoading" height="100%" style="width: 100%;" border>
                <el-table-column type="index" label="序号" width="55" align="center">
                </el-table-column>
                <el-table-column prop="TeacherName" label="教师" min-width="80" align="center">
                </el-table-column>
                <el-table-column label="班级名称" min-width="160" align="center">
                    <template slot-scope="scope">
                        <template v-if="parseClassNames(scope.row.ClassNames).length === 0">
                            <span class="class-empty">-</span>
                        </template>
                        <template v-else-if="parseClassNames(scope.row.ClassNames).length === 1">
                            <span>{{ parseClassNames(scope.row.ClassNames)[0] }}</span>
                        </template>
                        <el-button
                            v-else
                            type="text"
                            size="small"
                            icon="el-icon-school"
                            class="class-multi-link"
                            @click.stop="openClassViewDialog(scope.row)">
                            {{ parseClassNames(scope.row.ClassNames)[0] }} · 共{{ parseClassNames(scope.row.ClassNames).length }}个
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="代课" min-width="80" align="center">
                    <template slot-scope="scope">
                        <el-link type="primary" :underline="false" @click="showDetail(scope.row, 1)">{{
                            scope.row.SubstituteCount }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="被代课" min-width="80" align="center">
                    <template slot-scope="scope">
                        <el-link type="primary" :underline="false" @click="showDetail(scope.row, 2)">{{
                            scope.row.BeSubstitutedCount }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="调课" min-width="80" align="center">
                    <template slot-scope="scope">
                        <el-link type="primary" :underline="false" @click="showDetail(scope.row, 3)">{{
                            scope.row.SwapCount }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="教务安排(待指派)" min-width="100" align="center">
                    <template slot-scope="scope">
                        <el-link type="primary" :underline="false" @click="showDetail(scope.row, 4)">{{
                            scope.row.AdminArrangePendingCount }}</el-link>
                    </template>
                </el-table-column>
            </el-table>
            </div>

            <el-col :span="24" class="toolbar">
                <el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange"
                    @size-change="handleSizeChange" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" :total="total"
                    style="float:right;">
                </el-pagination>
            </el-col>
                </el-tab-pane>

                <el-tab-pane label="明细" name="detail">
                    <div class="app-scope-tip">
                        <i class="el-icon-info"></i>
                        <span>明细只含<strong>已通过</strong>课节。类型/原因用顶部筛选；本栏可搜老师、班级、课节、原因。</span>
                    </div>
                    <div class="detail-filter-bar">
                        <el-input
                            v-model="flatFilters.keyword"
                            placeholder="搜老师/班级/课节/原因"
                            clearable
                            size="small"
                            prefix-icon="el-icon-search"
                            class="detail-keyword-input"
                            @keyup.enter.native="getFlatDetails(1)"
                            @clear="getFlatDetails(1)">
                        </el-input>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="getFlatDetails(1)">查询</el-button>
                        <el-tag
                            v-if="flatFilters.teacherMasterId"
                            type="warning"
                            size="small"
                            closable
                            class="flat-focus-tag"
                            @close="clearFlatTeacherFocus">
                            下钻：{{ flatFilters.focusTeacherName || '指定教师' }}
                        </el-tag>
                    </div>

                    <div class="tbl-scroll-host">
                    <el-table :data="flatDetailList" border v-loading="flatDetailLoading" size="small" height="100%"
                        class="adjust-detail-table" :header-cell-style="{ whiteSpace: 'nowrap' }" style="width: 100%;">
                        <el-table-column property="Submitter" label="提交人" width="80" align="center"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column property="HandleTypeText" label="类型" width="110" align="center">
                            <template slot-scope="scope">
                                <el-tag
                                    :type="scope.row.HandleTypeText === '调课' ? 'warning' : (scope.row.HandleTypeText === '教务安排(待指派)' ? 'info' : 'success')"
                                    size="mini"
                                    class="handle-type-tag">
                                    {{ scope.row.HandleTypeText }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="申请老师/班级" min-width="120" align="center">
                            <template slot-scope="scope">
                                <div class="detail-cell-stack">
                                    <span class="detail-cell-main">{{ scope.row.OriginalTeacherName || '-' }}</span>
                                    <span class="detail-cell-sub">{{ scope.row.ClassName || '-' }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="课节安排" min-width="200" align="left">
                            <template slot-scope="scope">
                                <div class="detail-cell-stack is-left" :title="(scope.row.LessonInfo || '') + '\n' + (scope.row.CourseName || '')">
                                    <span class="detail-cell-main">{{ scope.row.LessonInfo || '-' }}</span>
                                    <span class="detail-cell-sub">{{ scope.row.CourseName || '-' }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column property="NewTeacherName" label="被申请老师" width="96" align="center"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column label="原因" min-width="120" align="center">
                            <template slot-scope="scope">
                                <div class="detail-cell-stack">
                                    <el-tag type="info" size="mini">{{ scope.row.ReasonTypeName || scope.row.Type || '-' }}</el-tag>
                                    <span class="detail-cell-sub" :title="scope.row.Reason">{{ scope.row.Reason || '-' }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="状态/时间" width="120" align="center">
                            <template slot-scope="scope">
                                <div class="detail-cell-stack">
                                    <span class="detail-cell-main">{{ scope.row.Status || '-' }}</span>
                                    <span class="detail-cell-sub">{{ scope.row.ApplyTime || '-' }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="附件" width="100" align="center">
                            <template slot-scope="scope">
                                <div v-if="scope.row.AttachmentImageList && scope.row.AttachmentImageList.length" class="attach-thumbs">
                                    <oss-el-image
                                        v-for="(url, idx) in scope.row.AttachmentImageList"
                                        :key="idx"
                                        :src="url"
                                        :preview-src-list="scope.row.AttachmentImageList"
                                        :school-id="departmentId"
                                        fit="cover"
                                        class="attach-thumb"
                                    />
                                </div>
                                <span v-else class="attach-empty">-</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    </div>

                    <el-col :span="24" class="toolbar">
                        <el-pagination layout="total, sizes, prev, pager, next, jumper"
                            @current-change="handleFlatDetailPageChange"
                            @size-change="handleFlatDetailSizeChange"
                            :current-page="flatDetailPage"
                            :page-size="flatDetailPageSize"
                            :page-sizes="[10, 20, 50, 100]"
                            :total="flatDetailTotal"
                            style="float:right;">
                        </el-pagination>
                    </el-col>
                </el-tab-pane>

                <el-tab-pane label="申请记录" name="applications">
                    <div class="app-scope-tip">
                        <i class="el-icon-info"></i>
                        <span>左侧选<strong>学校</strong>看全部、选<strong>校区</strong>看该校区。顶部「类型」筛代课/调课/教务待指派；「导出申请记录」跟当前筛选一致。</span>
                    </div>
                    <div class="detail-filter-bar">
                        <el-select v-model="appFilters.status" placeholder="申请状态" clearable size="small"
                            class="detail-type-select" @change="getApplicationRecords(1)">
                            <el-option label="全部状态" :value="null"></el-option>
                            <el-option label="待审批" :value="0"></el-option>
                            <el-option label="已通过" :value="1"></el-option>
                            <el-option label="已驳回" :value="2"></el-option>
                            <el-option label="已撤销" :value="3"></el-option>
                        </el-select>
                        <el-input
                            v-model="appFilters.keyword"
                            placeholder="搜申请人/校区/课节/原因"
                            clearable
                            size="small"
                            prefix-icon="el-icon-search"
                            class="detail-keyword-input"
                            @keyup.enter.native="getApplicationRecords(1)"
                            @clear="getApplicationRecords(1)">
                        </el-input>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="getApplicationRecords(1)">查询</el-button>
                    </div>

                    <div class="tbl-scroll-host">
                    <el-table :data="appRecordList" border v-loading="appRecordLoading" size="small" height="100%"
                        class="adjust-detail-table" :header-cell-style="{ whiteSpace: 'nowrap' }" style="width: 100%;">
                        <el-table-column label="申请人" width="110" align="center">
                            <template slot-scope="scope">
                                <div class="detail-cell-stack">
                                    <span class="detail-cell-main">{{ scope.row.ApplicantTeacherName || '-' }}</span>
                                    <el-tag v-if="scope.row.IsAgentApply" type="warning" size="mini" effect="plain"
                                        :title="'代' + (scope.row.AgentApplyForTeacherNames || '') + '申请'">代申请</el-tag>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column property="CampusName" label="校区" min-width="130" align="center"
                            show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span class="app-cell-text" :title="scope.row.CampusName">{{ scope.row.CampusName || '-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="申请时段" min-width="168" align="center">
                            <template slot-scope="scope">
                                <div class="detail-cell-stack">
                                    <span class="app-cell-text" :title="formatAppDateRange(scope.row)">{{ formatAppDateRange(scope.row) }}</span>
                                    <span class="detail-cell-sub">第{{ scope.row.StartClassNo }}节 ~ 第{{ scope.row.EndClassNo }}节</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column property="HandleTypeSummary" label="类型" width="88" align="center"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column label="课节摘要" min-width="150" align="left">
                            <template slot-scope="scope">
                                <div class="app-lesson-cell" @click="openApplicationDetail(scope.row)">
                                    <span class="app-lesson-count">{{ getLessonCount(scope.row) }}节</span>
                                    <span class="app-lesson-preview">{{ getLessonPreview(scope.row) }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column property="AssignedTeacherNames" label="代课/对端教师" min-width="110" align="center"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column label="原因" min-width="120" align="center">
                            <template slot-scope="scope">
                                <div class="detail-cell-stack">
                                    <el-tag type="info" size="mini" effect="plain">{{ scope.row.ReasonTypeName || '-' }}</el-tag>
                                    <span class="detail-cell-sub" :title="scope.row.ReasonDetail">{{ scope.row.ReasonDetail || '-' }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="状态/审批人" width="128" align="center">
                            <template slot-scope="scope">
                                <div class="detail-cell-stack app-status-cell" @click="openApplicationDetail(scope.row)">
                                    <el-tag :type="appStatusTagType(scope.row.Status)" size="mini" effect="plain">
                                        {{ scope.row.StatusName || '-' }}
                                    </el-tag>
                                    <span class="detail-cell-sub" :title="scope.row.CurrentApproverNames">
                                        {{ scope.row.Status === 0
                                            ? (scope.row.StatusName === '待改单重提'
                                                ? '等待申请人重新提交'
                                                : (scope.row.CurrentApproverNames || '待审批'))
                                            : (scope.row.CreateTime || '-').toString().substring(0, 16).replace('T', ' ') }}
                                    </span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="附件" width="100" align="center">
                            <template slot-scope="scope">
                                <div v-if="scope.row.AttachmentImageList && scope.row.AttachmentImageList.length" class="attach-thumbs">
                                    <oss-el-image
                                        v-for="(url, idx) in scope.row.AttachmentImageList"
                                        :key="idx"
                                        :src="url"
                                        :preview-src-list="scope.row.AttachmentImageList"
                                        :school-id="departmentId"
                                        fit="cover"
                                        class="attach-thumb"
                                    />
                                </div>
                                <span v-else class="attach-empty">-</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    </div>

                    <el-col :span="24" class="toolbar">
                        <el-pagination layout="total, sizes, prev, pager, next, jumper"
                            @current-change="handleAppRecordPageChange"
                            @size-change="handleAppRecordSizeChange"
                            :current-page="appRecordPage"
                            :page-size="appRecordPageSize"
                            :page-sizes="[10, 20, 50, 100]"
                            :total="appRecordTotal"
                            style="float:right;">
                        </el-pagination>
                    </el-col>
                </el-tab-pane>
            </el-tabs>

            <!-- 多班级查看弹窗（参考考勤规则应用部门）。最后更新：2026-09-14 -->
            <el-dialog
                :title="classViewDialog.title"
                :visible.sync="classViewDialog.visible"
                width="560px"
                :close-on-click-modal="false"
                append-to-body
                custom-class="cas-class-view-dialog">
                <div class="cas-view-head">
                    <div class="cas-view-head-item">
                        <span class="label">教师：</span>
                        <span class="val">{{ classViewDialog.teacherName || '-' }}</span>
                    </div>
                    <div class="cas-view-head-item">
                        <span class="label">总数：</span>
                        <span class="val count-badge">{{ classViewDialog.classes.length }} 个班级</span>
                    </div>
                </div>

                <div class="cas-view-toolbar">
                    <el-input
                        v-model="classViewDialog.filterKey"
                        size="small"
                        placeholder="搜索班级名称..."
                        prefix-icon="el-icon-search"
                        clearable
                        class="cas-view-search-input" />
                    <el-button size="small" type="primary" plain icon="el-icon-document-copy" @click="copyAllClassNames">
                        复制全部班级
                    </el-button>
                </div>

                <el-table :data="filteredViewClasses" size="small" max-height="320" border stripe>
                    <el-table-column type="index" label="序号" width="70" align="center" />
                    <el-table-column prop="name" label="班级名称" min-width="240" show-overflow-tooltip />
                    <el-table-column label="操作" width="90" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" icon="el-icon-document-copy"
                                @click="copySingleClassName(scope.row.name)">复制</el-button>
                        </template>
                    </el-table-column>
                    <div slot="empty">暂无匹配的班级</div>
                </el-table>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="classViewDialog.visible = false">关闭</el-button>
                </div>
            </el-dialog>

            <!-- 申请记录详情：高密度信息条 + 课节表 + 审批卡片。最后更新：2026-10-22 -->
            <el-dialog
                title="申请记录详情"
                :visible.sync="applicationDialog.visible"
                width="960px"
                :close-on-click-modal="false"
                append-to-body
                custom-class="cas-application-dialog">
                <div v-if="applicationDialog.row" class="application-detail-dialog">
                    <div class="app-meta-bar">
                        <div class="app-meta-identity">
                            <span class="app-meta-name">{{ applicationDialog.row.ApplicantTeacherName || '-' }}</span>
                            <el-tag :type="appStatusTagType(applicationDialog.row.Status)" size="mini" effect="plain">
                                {{ applicationDialog.row.StatusName || '-' }}
                            </el-tag>
                            <el-tag v-if="applicationDialog.row.IsAgentApply" type="warning" size="mini" effect="plain">
                                代申请
                            </el-tag>
                        </div>
                        <div class="app-meta-fields">
                            <span class="app-meta-field">
                                <em>校区</em>{{ applicationDialog.row.CampusName || '-' }}
                            </span>
                            <span v-if="applicationDialog.row.IsAgentApply" class="app-meta-field">
                                <em>代谁</em>{{ applicationDialog.row.AgentApplyForTeacherNames || '-' }}
                            </span>
                            <span class="app-meta-field">
                                <em>原因</em>{{ applicationDialog.row.ReasonTypeName || '-' }}
                            </span>
                            <span class="app-meta-field">
                                <em>时段</em>{{ formatAppDateRange(applicationDialog.row) }}
                                · 第{{ applicationDialog.row.StartClassNo }}~{{ applicationDialog.row.EndClassNo }}节
                            </span>
                            <span class="app-meta-field app-meta-field--grow" :title="applicationDialog.row.ReasonDetail">
                                <em>说明</em>{{ applicationDialog.row.ReasonDetail || '-' }}
                            </span>
                        </div>
                    </div>

                    <div class="flow-panel">
                        <div class="flow-panel-head">
                            <div class="flow-panel-title">
                                <i class="el-icon-date"></i>
                                <span>课节明细</span>
                                <span class="flow-count">{{ getLessonCount(applicationDialog.row) }} 节</span>
                            </div>
                        </div>
                        <el-table
                            v-if="applicationDialog.lessonList.length"
                            :data="applicationDialog.lessonList"
                            size="mini"
                            border
                            max-height="240"
                            class="app-lesson-table">
                            <el-table-column type="index" label="#" width="40" align="center"></el-table-column>
                            <el-table-column label="课节" width="190" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{ formatLessonPeriod(scope.row) }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="DepartmentName" label="班级" width="90" align="center"
                                show-overflow-tooltip></el-table-column>
                            <el-table-column prop="OriginalCourseName" label="课程" width="120" align="center"
                                show-overflow-tooltip></el-table-column>
                            <el-table-column prop="OriginalTeacherName" label="原任课" width="80" align="center"
                                show-overflow-tooltip></el-table-column>
                            <el-table-column label="类型" width="120" align="center">
                                <template slot-scope="scope">
                                    <el-tag size="mini" effect="plain" :type="lessonHandleTagType(scope.row.HandleType)">
                                        {{ scope.row.HandleTypeName || '-' }}
                                    </el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column label="代课/对端" min-width="88" align="center" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span>{{ scope.row.NewTeacherName || (scope.row.HandleType === 3 ? '待指派' : '-') }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="对端课节" min-width="110" align="center" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{ formatRelatedLesson(scope.row) }}
                                </template>
                            </el-table-column>
                        </el-table>
                        <div v-else class="app-empty-tip">暂无课节明细</div>
                    </div>

                    <div class="flow-panel">
                        <div class="flow-panel-head">
                            <div class="flow-panel-title">
                                <i class="el-icon-s-check"></i>
                                <span>审批进度</span>
                                <span v-if="applicationDialog.row.CreateTime" class="flow-create-time">
                                    {{ formatDateTime(applicationDialog.row.CreateTime) }}
                                </span>
                                <span v-if="applicationDialog.row.ApprovalSteps && applicationDialog.row.ApprovalSteps.length"
                                    class="flow-count">
                                    {{ applicationDialog.row.ApprovalSteps.length }} 人
                                </span>
                            </div>
                        </div>
                        <div
                            v-if="applicationDialog.row.ApprovalSteps && applicationDialog.row.ApprovalSteps.length"
                            class="approval-steps-grid">
                            <div
                                v-for="(step, index) in applicationDialog.row.ApprovalSteps"
                                :key="`${step.StepNumber}-${index}`"
                                class="approval-step-card"
                                :class="['step-tone-' + (((step.StepNumber || 1) - 1) % 4), 'is-' + (step.Status || 'Pending')]">
                                <div class="step-card-head">
                                    <div class="step-card-main">
                                        <span class="step-badge">{{ step.StepNumber }}</span>
                                        <span class="step-name">{{ step.ApproverName || '-' }}</span>
                                    </div>
                                    <el-tag size="mini" :type="approvalStepTagType(step.Status)" effect="plain">
                                        {{ approvalStepStatusText(step.Status) }}
                                    </el-tag>
                                </div>
                                <div class="step-card-time">
                                    {{ step.ApprovedAt ? formatDateTime(step.ApprovedAt) : '待处理' }}
                                </div>
                                <div v-if="step.Comments" class="step-card-comment">{{ step.Comments }}</div>
                            </div>
                        </div>
                        <div v-else class="app-empty-tip">暂无审批流程记录</div>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="applicationDialog.visible = false">关闭</el-button>
                </div>
            </el-dialog>
        </section>
    </section>
</template>

<script>
import dateUtil from '../../../util/date';
import { getAdjustStatisticsList, exportAdjustStatistics, exportAdjustApplicationRecords, getAdjustStatisticsDetailList, getAdjustApplicationRecords, getCourseConfig } from '../../api/modules/schedule-course';
import { getSemesterList } from '../../api/modules/misc';
import DepartmentPane from "@/components/DepartmentPane";

export default {
    components: { DepartmentPane },
    data() {
        return {
            departmentId: null,
            semesterList: [],
            selectedSemesterId: null,
            currentSemesterObj: null,
            filters: {
                teacherName: '',
                operationType: 0,
                /** 申请原因：1~4；空/null 表示全部。最后更新：2026-10-21 */
                reasonType: null,
                dateRange: []
            },
            timeRange: 'month',
            activeTab: 'stats',

            statistics: [],
            summary: {
                TotalSubstituteCount: 0,
                TotalBeSubstitutedCount: 0,
                TotalSwapCount: 0,
                TotalAdminArrangePendingCount: 0
            },

            total: 0,
            page: 1,
            pageSize: 10,
            listLoading: false,

            // 明细 Tab：类型用顶部 filters.operationType；原因与顶部共用。最后更新：2026-10-22
            flatFilters: {
                keyword: '',
                teacherMasterId: 0,
                focusTeacherName: ''
            },
            reasonTypeOptions: [
                { value: 1, label: '因公' },
                { value: 2, label: '因私' },
                { value: 3, label: '病假' },
                { value: 4, label: '其他' }
            ],
            flatDetailList: [],
            flatDetailTotal: 0,
            flatDetailPage: 1,
            flatDetailPageSize: 10,
            flatDetailLoading: false,

            // 申请记录 Tab。最后更新：2026-10-22
            appFilters: {
                status: null,
                keyword: ''
            },
            appRecordList: [],
            appRecordTotal: 0,
            appRecordPage: 1,
            appRecordPageSize: 10,
            appRecordLoading: false,
            applicationDialog: {
                visible: false,
                row: null,
                lessonList: []
            },

            // 多班级查看弹窗。最后更新：2026-09-14
            classViewDialog: {
                visible: false,
                title: '查看任教班级',
                teacherName: '',
                classes: [],
                filterKey: ''
            }
        }
    },
    computed: {
        /** 弹窗中过滤后的班级列表 */
        filteredViewClasses() {
            const list = this.classViewDialog.classes || [];
            const key = (this.classViewDialog.filterKey || '').trim().toLowerCase();
            if (!key) {
                return list.map(name => ({ name }));
            }
            return list
                .filter(name => String(name).toLowerCase().includes(key))
                .map(name => ({ name }));
        }
    },
    methods: {
        /**
         * 解析班级名称字符串为数组（顿号分隔）
         */
        parseClassNames(val) {
            if (!val) return [];
            if (Array.isArray(val)) return val.filter(Boolean);
            return String(val).split('、').map(s => s.trim()).filter(s => s.length > 0);
        },
        /**
         * 打开任教班级查看弹窗。最后更新：2026-09-14
         */
        openClassViewDialog(row) {
            if (!row) return;
            const classes = this.parseClassNames(row.ClassNames);
            this.classViewDialog = {
                visible: true,
                title: `查看任教班级 - ${row.TeacherName || '教师'}`,
                teacherName: row.TeacherName || '',
                classes,
                filterKey: ''
            };
        },
        copyAllClassNames() {
            const names = (this.filteredViewClasses || []).map(item => item.name).filter(Boolean);
            if (!names.length) {
                this.$message.warning('暂无可复制的班级');
                return;
            }
            this.copyTextToClipboard(names.join('、'), `已复制 ${names.length} 个班级`);
        },
        copySingleClassName(text) {
            if (!text) {
                this.$message.warning('内容为空');
                return;
            }
            this.copyTextToClipboard(String(text), '已复制');
        },
        copyTextToClipboard(text, successMsg) {
            const done = () => this.$message.success(successMsg || '已复制');
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text).then(done).catch(() => this.fallbackCopyText(text, done));
                return;
            }
            this.fallbackCopyText(text, done);
        },
        fallbackCopyText(text, onSuccess) {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.position = 'fixed';
            textarea.style.left = '-9999px';
            document.body.appendChild(textarea);
            textarea.select();
            try {
                document.execCommand('copy');
                if (typeof onSuccess === 'function') onSuccess();
            } catch (e) {
                this.$message.error('复制失败');
            }
            document.body.removeChild(textarea);
        },
        /**
         * 左侧家校通讯录选中节点后加载学期并刷新统计。最后更新：2026-09-14
         */
        treeNodeClick(node) {
            let deptId = null;
            if (!node) deptId = null;
            else if (node.value !== undefined) deptId = node.value;
            else if (node.Id !== undefined) deptId = node.Id;
            else if (node.id !== undefined) deptId = node.id;

            this.departmentId = deptId;

            // 总平台限制
            if (this.departmentId == 0 || this.departmentId == -2) {
                this.$message({
                    message: '抱歉，暂不支持总平台级别的数据统计，请选择具体的学校或班级。',
                    type: 'error'
                });
                // 清空数据
                this.statistics = [];
                this.summary = {
                    TotalSubstituteCount: 0,
                    TotalBeSubstitutedCount: 0,
                    TotalSwapCount: 0,
                    TotalAdminArrangePendingCount: 0
                };
                this.total = 0;
                this.flatDetailList = [];
                this.flatDetailTotal = 0;
                this.appRecordList = [];
                this.appRecordTotal = 0;
                return;
            }

            this.loadSemesters();
        },
        loadSemesters() {
            if (!this.departmentId) return;
            getCourseConfig({ DepartmentId: this.departmentId }).then(res => {
                const data = res && res.data && res.data.response;
                if (data && Array.isArray(data.CourseAdjustmentReasonTypes) && data.CourseAdjustmentReasonTypes.length) {
                    this.reasonTypeOptions = data.CourseAdjustmentReasonTypes.map(x => ({
                        value: Number(x.Value),
                        label: x.Name
                    }));
                }
            }).catch(() => {});
            getSemesterList({ departmentId: this.departmentId }).then(res => {
                if (res.success && res.response && res.response.length > 0) {
                    this.semesterList = res.response;
                    let current = res.response.find(s => s.IsCurrent === 1) || res.response[0];
                    this.selectedSemesterId = current.Id;
                    this.currentSemesterObj = current;
                    // 默认选择“全学期”
                    this.handleTimeRangeChange('semester');
                } else {
                    this.semesterList = [];
                    this.selectedSemesterId = null;
                    this.currentSemesterObj = null;
                    this.handleTimeRangeChange('month');
                }
            });
        },
        handleSemesterChange(val) {
            let s = this.semesterList.find(x => x.Id === val);
            if (s) {
                this.currentSemesterObj = s;
                if (this.timeRange === 'semester') {
                    this.handleTimeRangeChange('semester');
                } else {
                    this.handleSearch();
                }
            }
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getRecords();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getRecords(1);
        },
        handleCustomTimeCommand() {
            this.timeRange = 'custom';
        },
        /**
         * 仅全学期模式传 SemesterId；其它时间模式只按调课日期。最后更新：2026-07-23
         */
        resolveQuerySemesterId() {
            if (this.timeRange !== 'semester') return 0;
            return this.selectedSemesterId || 0;
        },
        onCustomDateChange(val) {
            if (val && val.length === 2) {
                this.timeRange = 'custom';
                this.handleSearch();
            }
        },
        // 时间范围快捷切换
        handleTimeRangeChange(val) {
            this.timeRange = val;
            const todayDate = new Date();
            const todayStr = dateUtil.formatDate.format(todayDate, 'yyyy-MM-dd');
            let start = '';
            let end = '';

            if (val === 'today') {
                start = todayStr;
                end = todayStr;
            } else if (val === 'week') {
                start = dateUtil.formatDate.format(dateUtil.getStartOfWeek(todayDate), 'yyyy-MM-dd');
                end = dateUtil.formatDate.format(dateUtil.getEndOfWeek(todayDate), 'yyyy-MM-dd');
            } else if (val === 'month') {
                start = dateUtil.formatDate.format(dateUtil.getStartOfMonth(todayDate), 'yyyy-MM-dd');
                end = dateUtil.formatDate.format(dateUtil.getEndOfMonth(todayDate), 'yyyy-MM-dd');
            } else if (val === 'semester') {
                if (this.currentSemesterObj && this.currentSemesterObj.StartDate && this.currentSemesterObj.EndDate) {
                    start = this.currentSemesterObj.StartDate.substring(0, 10);
                    end = this.currentSemesterObj.EndDate.substring(0, 10);
                } else {
                    start = dateUtil.formatDate.format(dateUtil.addMonths(todayDate, -6), 'yyyy-MM-dd');
                    end = todayStr; // fallback if no semester available
                }
            } else {
                return; // custom controlled by date-picker change
            }

            this.filters.dateRange = [start, end];
            this.handleSearch();
        },
        /** 顶部查询：按当前 Tab 刷新；姓名空时同步清掉明细下钻。最后更新：2026-10-22 */
        handleSearch() {
            if (!(this.filters.teacherName || '').trim()) {
                this.flatFilters.teacherMasterId = 0;
                this.flatFilters.focusTeacherName = '';
            }
            if (this.activeTab === 'detail') {
                this.getFlatDetails(1);
            } else if (this.activeTab === 'applications') {
                this.getApplicationRecords(1);
            } else {
                this.getRecords(1);
            }
        },
        /** 清空顶部教师姓名时，同步取消明细教师下钻 */
        onTeacherNameCleared() {
            this.flatFilters.teacherMasterId = 0;
            this.flatFilters.focusTeacherName = '';
            if (this.activeTab === 'detail') {
                this.getFlatDetails(1);
            } else if (this.activeTab === 'applications') {
                this.getApplicationRecords(1);
            }
        },
        onTabClick() {
            if (this.activeTab === 'detail') {
                this.getFlatDetails();
            } else if (this.activeTab === 'applications') {
                this.getApplicationRecords();
            } else {
                this.getRecords();
            }
        },
        buildSharedQueryParams(page, pageSize) {
            let startDate = '';
            let endDate = '';
            if (this.filters.dateRange && this.filters.dateRange.length === 2) {
                startDate = this.filters.dateRange[0];
                endDate = this.filters.dateRange[1];
            }
            const para = {
                Page: page,
                PageSize: pageSize,
                TeacherName: this.filters.teacherName,
                StartDate: startDate,
                EndDate: endDate,
                DepartmentId: this.departmentId,
                SemesterId: this.resolveQuerySemesterId()
            };
            // 顶部类型三端共用：统计筛教师次数，明细/申请记录筛处理类型。最后更新：2026-10-22
            if (this.filters.operationType > 0) {
                para.OperationType = this.filters.operationType;
            }
            if (this.filters.reasonType) {
                para.ReasonType = this.filters.reasonType;
            }
            return para;
        },
        // 获取统计
        getRecords(resetPage) {
            if (resetPage) this.page = resetPage;
            if (!this.departmentId) return;

            let para = this.buildSharedQueryParams(this.page, this.pageSize);

            this.listLoading = true;
            getAdjustStatisticsList(para).then((res) => {
                if (res.success) {
                    this.total = res.response.PageData.dataCount;
                    this.statistics = res.response.PageData.data;
                    this.summary = res.response.Summary || {};
                } else {
                    this.$message.error(res.msg || '获取统计失败');
                }
                this.listLoading = false;
            }).catch(() => {
                this.listLoading = false;
                this.$message.error('网络请求异常');
            });
        },
        /**
         * 导出：申请记录 Tab 导出申请单；其余 Tab 导出统计+明细。最后更新：2026-10-22
         */
        exportExcel() {
            if (this.activeTab === 'applications') {
                return this.exportApplicationRecords();
            }
            const para = this.buildSharedQueryParams(1, 999999);
            return exportAdjustStatistics(para).then((res) => {
                this.downloadBlob(res.data, `代调课统计报表_${dateUtil.formatDate.format(new Date(), 'yyyyMMddhhmmss')}.xlsx`);
            }).catch(() => {
                this.$message.error("导出失败");
            });
        },
        exportApplicationRecords() {
            if (!this.departmentId) {
                this.$message.warning('请先选择学校或部门');
                return;
            }
            const para = Object.assign(this.buildSharedQueryParams(1, 999999), {
                Keyword: this.appFilters.keyword || ''
            });
            if (this.appFilters.status === 0 || this.appFilters.status > 0) {
                para.Status = this.appFilters.status;
            }
            return exportAdjustApplicationRecords(para).then((res) => {
                this.downloadBlob(res.data, `代调课申请记录_${dateUtil.formatDate.format(new Date(), 'yyyyMMddhhmmss')}.xlsx`);
            }).catch(() => {
                this.$message.error("导出申请记录失败");
            });
        },
        downloadBlob(blob, fileName) {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        },
        /**
         * 顶部汇总卡片：切到明细 Tab，按操作类型筛选（不限定教师）。最后更新：2026-10-21
         */
        showSummaryDetail(type) {
            if (type === 1 && !(this.summary.TotalSubstituteCount > 0)) return;
            if (type === 2 && !(this.summary.TotalBeSubstitutedCount > 0)) return;
            if (type === 3 && !(this.summary.TotalSwapCount > 0)) return;
            if (type === 4 && !(this.summary.TotalAdminArrangePendingCount > 0)) return;

            this.filters.operationType = type;
            this.flatFilters.teacherMasterId = 0;
            this.flatFilters.focusTeacherName = '';
            this.flatFilters.keyword = '';
            this.activeTab = 'detail';
            this.getFlatDetails(1);
        },
        /**
         * 统计表点数字：切到明细 Tab，并按下钻教师 + 类型筛选。最后更新：2026-10-22
         */
        showDetail(row, type) {
            if (!row) return;
            if (type === 1 && row.SubstituteCount === 0) return;
            if (type === 2 && row.BeSubstitutedCount === 0) return;
            if (type === 3 && row.SwapCount === 0) return;
            if (type === 4 && row.AdminArrangePendingCount === 0) return;

            this.filters.operationType = type;
            this.flatFilters.teacherMasterId = row.TeacherMasterId || 0;
            this.flatFilters.focusTeacherName = row.TeacherName || '';
            this.flatFilters.keyword = '';
            // 与顶部教师姓名同步，避免「上面空了、下面仍下钻」的错觉
            this.filters.teacherName = row.TeacherName || '';
            this.activeTab = 'detail';
            this.getFlatDetails(1);
        },
        clearFlatTeacherFocus() {
            this.flatFilters.teacherMasterId = 0;
            this.flatFilters.focusTeacherName = '';
            this.filters.teacherName = '';
            this.getFlatDetails(1);
        },
        handleFlatDetailPageChange(val) {
            this.flatDetailPage = val;
            this.getFlatDetails();
        },
        handleFlatDetailSizeChange(val) {
            this.flatDetailPageSize = val;
            this.getFlatDetails(1);
        },
        getFlatDetails(resetPage) {
            if (resetPage) this.flatDetailPage = resetPage;
            if (!this.departmentId) return;

            const para = Object.assign(this.buildSharedQueryParams(this.flatDetailPage, this.flatDetailPageSize), {
                Type: 0,
                TeacherMasterId: this.flatFilters.teacherMasterId || 0,
                Keyword: this.flatFilters.keyword || ''
            });

            this.flatDetailLoading = true;
            getAdjustStatisticsDetailList(para).then(res => {
                if (res.success) {
                    this.flatDetailTotal = res.response.dataCount;
                    const rows = res.response.data || [];
                    this.flatDetailList = rows.map(row => ({
                        ...row,
                        AttachmentImageList: this.parseAttachmentImages(row.AttachmentImages)
                    }));
                } else {
                    this.$message.error(res.msg || '获取明细失败');
                }
                this.flatDetailLoading = false;
            }).catch(() => {
                this.flatDetailLoading = false;
                this.$message.error('网络请求异常');
            });
        },
        /** 解析申请附件图片 URL（逗号分隔）。最后更新：2026-09-21 */
        parseAttachmentImages(raw) {
            if (!raw) return [];
            return String(raw).split(',').map(s => s.trim()).filter(Boolean);
        },
        /**
         * 申请记录列表。最后更新：2026-10-22
         */
        getApplicationRecords(resetPage) {
            if (resetPage) this.appRecordPage = resetPage;
            if (!this.departmentId) return;

            const para = Object.assign(this.buildSharedQueryParams(this.appRecordPage, this.appRecordPageSize), {
                Keyword: this.appFilters.keyword || ''
            });
            if (this.appFilters.status === 0 || this.appFilters.status > 0) {
                para.Status = this.appFilters.status;
            }

            this.appRecordLoading = true;
            getAdjustApplicationRecords(para).then(res => {
                if (res.success) {
                    this.appRecordTotal = res.response.dataCount;
                    const rows = res.response.data || [];
                    this.appRecordList = rows.map(row => ({
                        ...row,
                        AttachmentImageList: this.parseAttachmentImages(row.AttachmentImages)
                    }));
                } else {
                    this.$message.error(res.msg || '获取申请记录失败');
                }
                this.appRecordLoading = false;
            }).catch(() => {
                this.appRecordLoading = false;
                this.$message.error('网络请求异常');
            });
        },
        handleAppRecordPageChange(val) {
            this.appRecordPage = val;
            this.getApplicationRecords();
        },
        handleAppRecordSizeChange(val) {
            this.appRecordPageSize = val;
            this.getApplicationRecords(1);
        },
        formatAppDateRange(row) {
            if (!row) return '-';
            const start = (row.StartDate || '').toString().substring(0, 10);
            const end = (row.EndDate || '').toString().substring(0, 10);
            if (!start && !end) return '-';
            if (start === end) return start || end;
            return `${start} ~ ${end}`;
        },
        /**
         * 解析课节明细：优先用后端 Lessons，否则回退摘要字符串。最后更新：2026-10-22
         */
        parseLessonList(row) {
            if (!row) return [];
            const rawLessons = row.Lessons || row.lessons;
            if (Array.isArray(rawLessons) && rawLessons.length) {
                return rawLessons.map(item => ({
                    AdjustDate: item.AdjustDate || item.adjustDate,
                    DayOfWeekName: item.DayOfWeekName || item.dayOfWeekName || '',
                    ClassNo: item.ClassNo != null ? item.ClassNo : item.classNo,
                    DepartmentName: item.DepartmentName || item.departmentName || '',
                    OriginalCourseName: item.OriginalCourseName || item.originalCourseName || '',
                    OriginalTeacherName: item.OriginalTeacherName || item.originalTeacherName || '',
                    HandleType: item.HandleType != null ? item.HandleType : item.handleType,
                    HandleTypeName: item.HandleTypeName || item.handleTypeName || '-',
                    NewTeacherName: item.NewTeacherName || item.newTeacherName || '',
                    RelatedAdjustDate: item.RelatedAdjustDate || item.relatedAdjustDate,
                    RelatedClassNo: item.RelatedClassNo != null ? item.RelatedClassNo : item.relatedClassNo,
                    SummaryText: item.SummaryText || item.summaryText || ''
                }));
            }
            const raw = (row.LessonSummary || row.lessonSummary || '').toString().trim();
            if (!raw || raw === '-') return [];
            return raw.split(/[；;]/).map(s => s.trim()).filter(Boolean).map(text => ({
                SummaryText: text,
                DepartmentName: '',
                OriginalCourseName: '',
                OriginalTeacherName: '',
                HandleType: 0,
                HandleTypeName: '-',
                NewTeacherName: ''
            }));
        },
        getLessonCount(row) {
            if (!row) return 0;
            if (row.DetailCount != null && row.DetailCount > 0) return row.DetailCount;
            return this.parseLessonList(row).length;
        },
        getLessonPreview(row) {
            const list = this.parseLessonList(row);
            if (!list.length) return '-';
            const first = list[0].SummaryText || list[0].text || this.formatLessonPeriod(list[0]);
            return list.length > 1 ? `${first} 等` : first;
        },
        formatLessonPeriod(lesson) {
            if (!lesson) return '-';
            if (lesson.SummaryText && !lesson.AdjustDate) return lesson.SummaryText;
            const date = lesson.AdjustDate ? String(lesson.AdjustDate).substring(0, 10) : '';
            const day = lesson.DayOfWeekName || '';
            const classNo = lesson.ClassNo != null ? `第${lesson.ClassNo}节` : '';
            const text = `${date} ${day}${classNo}`.trim();
            return text || lesson.SummaryText || '-';
        },
        formatRelatedLesson(lesson) {
            if (!lesson || lesson.HandleType !== 1) return '-';
            if (!lesson.RelatedAdjustDate && !lesson.RelatedClassNo) return '-';
            const date = lesson.RelatedAdjustDate ? String(lesson.RelatedAdjustDate).substring(0, 10) : '';
            const classNo = lesson.RelatedClassNo != null ? `第${lesson.RelatedClassNo}节` : '';
            return `${date} ${classNo}`.trim() || '-';
        },
        lessonHandleTagType(handleType) {
            if (handleType === 1) return '';
            if (handleType === 2) return 'success';
            if (handleType === 3) return 'warning';
            return 'info';
        },
        openApplicationDetail(row) {
            if (!row) return;
            this.applicationDialog = {
                visible: true,
                row,
                lessonList: this.parseLessonList(row)
            };
        },
        approvalStepTagType(status) {
            if (status === 'Approved') return 'success';
            if (status === 'Rejected') return 'danger';
            if (status === 'Cancel') return 'info';
            return 'warning';
        },
        approvalStepStatusText(status) {
            if (status === 'Approved') return '已通过';
            if (status === 'Rejected') return '已驳回';
            if (status === 'Cancel') return '已取消';
            return '待审批';
        },
        formatDateTime(value) {
            if (!value) return '';
            return String(value).substring(0, 16).replace('T', ' ');
        },
        appStatusTagType(status) {
            if (status === 0) return 'warning';
            if (status === 1) return 'success';
            if (status === 2) return 'danger';
            if (status === 3) return 'info';
            return '';
        }
    }
}
</script>

<style scoped>
/* 申请记录表格与详情弹窗。最后更新：2026-10-22 */
.app-cell-text {
    display: block;
    overflow: hidden;
    color: #303133;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.app-lesson-cell {
    display: flex;
    flex-direction: column;
    gap: 2px;
    cursor: pointer;
    line-height: 1.35;
}

.app-lesson-cell:hover .app-lesson-count,
.app-lesson-cell:hover .app-lesson-preview {
    color: #2563eb;
}

.app-lesson-count {
    color: #2563eb;
    font-size: 13px;
    font-weight: 600;
}

.app-lesson-preview {
    overflow: hidden;
    color: #94a3b8;
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.app-status-cell {
    cursor: pointer;
}

.app-status-cell:hover .detail-cell-sub {
    color: #2563eb;
}

.application-detail-dialog {
    color: #606266;
}

/* 高密度信息条：字色偏 slate，避免纯黑过重。最后更新：2026-10-22 */
.app-meta-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 14px;
    margin-bottom: 10px;
    padding: 8px 12px;
    border: 1px solid #d6e8ff;
    border-radius: 6px;
    background: #f0f7ff;
}

.app-meta-identity {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    gap: 6px;
}

.app-meta-name {
    color: #334155;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
}

.app-meta-fields {
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px 16px;
    min-width: 0;
}

.app-meta-field {
    display: inline-flex;
    align-items: baseline;
    gap: 4px;
    max-width: 100%;
    color: #475569;
    font-size: 13px;
    font-weight: 400;
    line-height: 1.35;
    white-space: nowrap;
}

.app-meta-field em {
    font-style: normal;
    color: #94a3b8;
    font-weight: 400;
}

.app-meta-field--grow {
    overflow: hidden;
    text-overflow: ellipsis;
}

.flow-panel {
    margin-bottom: 8px;
    padding: 8px 10px;
    border: 1px solid #dbe4f0;
    border-radius: 6px;
    background: #f8fafc;
}

.flow-panel:last-of-type {
    margin-bottom: 0;
}

.flow-panel-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 6px;
}

.flow-panel-title {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    color: #475569;
    font-size: 13px;
    font-weight: 500;
}

.flow-panel-title i {
    color: #2563eb;
    font-size: 14px;
}

.flow-create-time {
    color: #64748b;
    font-size: 12px;
    font-weight: 400;
}

.flow-count {
    flex-shrink: 0;
    padding: 0 6px;
    border-radius: 999px;
    background: #eff6ff;
    color: #2563eb;
    font-size: 11px;
    font-weight: 600;
    line-height: 18px;
}

.app-lesson-table {
    width: 100%;
    color: #606266;
}

.application-detail-dialog ::v-deep .app-lesson-table th,
.application-detail-dialog ::v-deep .app-lesson-table td {
    color: #606266;
    font-weight: 400;
}

.application-detail-dialog ::v-deep .app-lesson-table th {
    color: #909399;
    font-weight: 500;
}

.app-empty-tip {
    padding: 10px 0;
    color: #94a3b8;
    font-size: 12px;
    text-align: center;
}

.approval-steps-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
    max-height: 220px;
    overflow-y: auto;
}

.approval-step-card {
    min-width: 0;
    padding: 8px 10px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    background: #fff;
}

.approval-step-card.step-tone-0 {
    border-color: #bfdbfe;
    background: #f8fbff;
}

.approval-step-card.step-tone-0 .step-badge {
    background: #2563eb;
}

.approval-step-card.step-tone-1 {
    border-color: #ddd6fe;
    background: #faf8ff;
}

.approval-step-card.step-tone-1 .step-badge {
    background: #7c3aed;
}

.approval-step-card.step-tone-2 {
    border-color: #99f6e4;
    background: #f0fdfa;
}

.approval-step-card.step-tone-2 .step-badge {
    background: #0d9488;
}

.approval-step-card.step-tone-3 {
    border-color: #fed7aa;
    background: #fff7ed;
}

.approval-step-card.step-tone-3 .step-badge {
    background: #ea580c;
}

.step-card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    margin-bottom: 4px;
}

.step-card-main {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
}

.step-badge {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    color: #fff;
    font-size: 11px;
    font-weight: 500;
    line-height: 18px;
    text-align: center;
}

.step-name {
    overflow: hidden;
    color: #475569;
    font-size: 13px;
    font-weight: 500;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.step-card-time {
    color: #94a3b8;
    font-size: 11px;
    line-height: 1.35;
}

.step-card-comment {
    margin-top: 4px;
    padding-left: 6px;
    border-left: 2px solid #bfdbfe;
    color: #64748b;
    font-size: 11px;
    line-height: 1.45;
    word-break: break-word;
    white-space: normal;
}

/* 全宽等分指标条，贴合表格宽度。最后更新：2026-09-14 */
.stat-summary {
    --stat-border: #e5e7eb;
    --stat-bg: #f8fafc;
    --stat-label: #64748b;
    --stat-value: #0f172a;
    --stat-accent: var(--btn-primary, #2563eb);
    --stat-pending: #d97706;

    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 10px;
    width: 100%;
    margin: 0 0 12px;
    background: transparent;
    border: none;
    border-radius: 0;
    overflow: visible;
}

.stat-summary-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
    min-height: 58px;
    padding: 10px 14px;
    background: var(--stat-bg);
    border: 1px solid var(--stat-border);
    border-radius: 8px;
    transition: background-color 0.2s ease, border-color 0.2s ease;
}

.stat-summary-item:last-child {
    border-right: 1px solid var(--stat-border);
}

.stat-summary-item:hover {
    background: #f1f5f9;
    border-color: #cbd5e1;
}

.stat-summary-item.is-clickable {
    cursor: pointer;
}

.stat-summary-item.is-clickable:hover .stat-summary-value {
    color: var(--stat-accent, #2563eb);
}

.stat-summary-label {
    color: var(--stat-label);
    font-size: 12px;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.stat-summary-value {
    color: var(--stat-value);
    font-size: 22px;
    font-weight: 600;
    line-height: 1.15;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.02em;
}

.stat-summary-item.is-pending {
    background: #fffbeb;
    border-color: #fde68a;
}

.stat-summary-item.is-pending:hover {
    background: #fef3c7;
    border-color: #fcd34d;
}

.stat-summary-item.is-pending .stat-summary-label {
    color: var(--stat-pending);
}

.stat-summary-item.is-pending .stat-summary-value {
    color: var(--stat-pending);
}

@media (max-width: 1100px) {
    .stat-summary {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
}

@media (max-width: 720px) {
    .stat-summary {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (prefers-reduced-motion: reduce) {
    .stat-summary-item {
        transition: none;
    }
}

/* 详情弹窗：申请类型等标签不换行截断 */
.handle-type-tag {
    white-space: nowrap;
    max-width: none;
    height: auto;
    line-height: 1.4;
    padding: 0 8px;
}

/* 明细合并列：主副两行紧凑展示。最后更新：2026-10-21 */
.detail-cell-stack {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    line-height: 1.35;
}

.detail-cell-stack.is-left {
    align-items: flex-start;
}

.detail-cell-main {
    color: #303133;
    font-size: 13px;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.detail-cell-sub {
    color: #909399;
    font-size: 12px;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.class-empty {
    color: #c0c4cc;
}

.class-multi-link {
    padding: 0;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.cas-tabs {
    margin-top: 4px;
}

/* 汇总条、明细筛选条不参与拉伸，留给表格滚动区。最后更新：2026-09-21 */
.cas-tabs >>> .el-tab-pane > .stat-summary,
.cas-tabs >>> .el-tab-pane > .detail-filter-bar,
.cas-tabs >>> .el-tab-pane > .app-scope-tip {
    flex: 0 0 auto;
}

.cas-tabs >>> .el-tab-pane > .el-col.toolbar {
    flex: 0 0 auto;
    margin-top: 8px;
}

.app-scope-tip {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    margin-bottom: 8px;
    padding: 6px 10px;
    border: 1px solid #d6e8ff;
    border-radius: 4px;
    background: #f0f7ff;
    color: #475569;
    font-size: 12px;
    line-height: 1.5;
}

.app-scope-tip i {
    margin-top: 2px;
    color: #2563eb;
}

.app-scope-tip strong {
    color: #1e3a5f;
    font-weight: 600;
}

.detail-filter-bar {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    min-height: 32px;
}

.detail-filter-bar .detail-type-select {
    width: 120px !important;
    flex: 0 0 auto;
}

.detail-filter-bar .detail-keyword-input {
    width: 260px !important;
    flex: 0 0 auto;
}

.detail-filter-bar .el-button {
    flex: 0 0 auto;
}

/* 顶部类型：刚好放下「教务安排(待指派)」。最后更新：2026-10-22 */
.toolbar-filter-bar .toolbar-field-w-type {
    width: 165px !important;
}

.flat-focus-tip {
    color: #64748b;
    font-size: 13px;
}

.flat-focus-tag {
    margin-left: 4px;
}

.attach-thumbs {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    justify-content: center;
}

.attach-thumb {
    width: 36px;
    height: 36px;
    border-radius: 4px;
}

.attach-empty {
    color: #94a3b8;
}
</style>

<style>
.cas-application-dialog .el-dialog__body {
    padding: 10px 16px 4px;
    color: #606266;
}

.cas-application-dialog .el-dialog__title {
    color: #475569;
    font-weight: 500;
}

.cas-application-dialog .el-dialog__footer {
    padding: 8px 16px 12px;
}

.cas-application-dialog .el-dialog__header {
    padding: 12px 16px 8px;
}

.cas-class-view-dialog .el-dialog__body {
    padding: 12px 20px 8px;
}

.cas-view-head {
    display: flex;
    flex-wrap: wrap;
    gap: 12px 20px;
    margin-bottom: 12px;
    padding: 10px 12px;
    background: #f0f7ff;
    border: 1px solid #d6e8ff;
    border-radius: 6px;
}

.cas-view-head-item {
    font-size: 13px;
    line-height: 1.4;
}

.cas-view-head-item .label {
    color: #64748b;
}

.cas-view-head-item .val {
    color: #0f172a;
    font-weight: 500;
}

.cas-view-head-item .count-badge {
    color: var(--btn-primary, #2563eb);
}

.cas-view-toolbar {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
}

.cas-view-search-input {
    flex: 1;
}
</style>
